import {inject, Injectable} from '@angular/core';
import {StateConfigService} from "../state/state-config.service";
import {CanActivateFn, Router} from '@angular/router';
import {Observable} from "rxjs";
import {StateControllerService} from "../../api";

@Injectable()
export class FeatureFlagGuardService {
  private router = inject(Router);
  private stateService = inject(StateConfigService);


  canActivate(flagName: string, redirectRoute: string): boolean {
    return true
  }
}

export function featureFlagGuard(
  flagName: string,
  redirectRoute: string
): CanActivateFn {
  return () => {
    const stateService: StateConfigService =
      inject(StateConfigService);
    const stateControllerService = inject(StateControllerService);
    const router: Router = inject(Router);
    return new Observable<boolean>(observer => {
      const featureConfig = stateService.getFeatureConfig();
      switch (flagName) {
        case 'bim-id': {
          if (featureConfig.bimIdCheck) {
            observer.next(true);
            observer.complete();
          } else {
            router.navigate(['projects', stateService.getProjectId(), 'dashboard']);
            observer.next(false);
            observer.complete();
          }
          break;
        }
        default: {
          if (featureConfig.swmCheck) {
            observer.next(true);
            observer.complete();
          } else {
            router.navigate(['projects', stateService.getProjectId(), 'dashboard']);
            observer.next(false);
            observer.complete();
          }
          break;
        }
      }
    });

  };
}
